module.exports = __webpack_public_path__ + "static/media/account_tree-24px.704b56ef.svg";